import { render, staticRenderFns } from "./bookOrderPage.vue?vue&type=template&id=205ad8b2&"
import script from "./bookOrderPage.vue?vue&type=script&lang=js&"
export * from "./bookOrderPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports